import { createLoginContainer } from './container'
import { LoginUI } from './ui/login'

const LoginContainer = createLoginContainer(LoginUI)

export const LoginPage = (props: { onLogin?: () => void }) => {
  return <LoginContainer onLogin={props.onLogin} />
}
